import * as React from "react";
import Icon from "common/icons";
import PACKS from "common/icons/packs";

const Banner = (props: { className?: string }) => {
  return <Icon icon={PACKS.POST_SHOW.BOTTOM_BANNER} {...props} />;
};

export default Banner;
